import { FC, ReactNode } from 'react'

import { AppDialog } from '@/Components/AppDialog'
import { Divider } from '@/Components/Divider'
import AttentionIcon from '@/Components/icons/attention.svg?react'
import { Button } from '@/Components/ui/button'
import { cn } from '@/lib/utils'

interface Props {
  isOpen: boolean
  onClose: () => void
  onConfirm?: () => void
  confirmLoading?: boolean
  content: ReactNode | string
  confirmText?: string
  cancelText?: string
  Icon?: FC<React.SVGProps<SVGSVGElement>>
  title: string
}

export const ConfirmDialog = ({ isOpen, onClose, onConfirm, confirmText, cancelText, Icon, title, content, confirmLoading }: Props) => {
  return (
    <AppDialog hideCloseButton isOpen={isOpen} onOpenChange={onClose} dialogContentClassName='max-w-sm !p-0'>
      <div className='mb-3 flex flex-col items-center gap-4 pt-6'>
        {Icon ? <Icon className='size-8' /> : <AttentionIcon className='size-8' />}
        <div className='text-lg font-medium'>{title}</div>
      </div>
      <p className='text-text-secondary p-6 pt-0 text-center text-base'>{content}</p>
      <Divider />
      <div className='flex items-center gap-3 p-6'>
        {confirmText && (
          <Button
            loading={confirmLoading}
            variant='ghost'
            size='sm'
            onClick={onConfirm}
            className={cn('text-button-secondary-border-default text-base', confirmLoading !== undefined && 'relative min-w-fit')}
          >
            {confirmLoading !== undefined && !confirmLoading && <span className='invisible inline-block size-4' aria-hidden='true' />}
            {confirmText}
          </Button>
        )}
        {cancelText && (
          <Button size='sm' variant='ghost' onClick={onClose} className='text-text-secondary text-base'>
            {cancelText}
          </Button>
        )}
      </div>
    </AppDialog>
  )
}
